// extracted by mini-css-extract-plugin
export default {"main":"MPKOOO_main__Z0Yvv","cover":"MPKOOO_cover__JfYxd","flex_col":"MPKOOO_flex_col__su3k9"};